var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentosFirmadosNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.04,
    height: 34.33,
    viewBox: "0 0 30.04 34.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #316094;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Documentos_Firmados",
    "data-name": "Pictograma - Documentos Firmados",
    transform: "translate(-605.23 -172.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4401",
    "data-name": "Trazado 4401",
    className: "cls-1",
    d: "M626.3,178a6.03,6.03,0,0,0-1.28-2.15,4.348,4.348,0,0,0-.48-.48,6.292,6.292,0,0,0-2.14-1.28,6.116,6.116,0,0,0-2.15-.38h-.01a6.274,6.274,0,0,0-2.13.37,6.155,6.155,0,0,0-2.15,1.27,3.934,3.934,0,0,0-.5.5,6.031,6.031,0,0,0-1.28,2.15h-8.95v30.04h30.04V178Zm6.83,27.9H607.38v-25.75h6.42c0-.07.01,0,.01,0h2.14a1.619,1.619,0,0,1,.01-.22,4.1,4.1,0,0,1,.57-1.93,4.325,4.325,0,0,1,1.58-1.57,4.264,4.264,0,0,1,2.13-.57h.01a4.3,4.3,0,0,1,4.28,4.29h8.6Z",
    transform: "translate(0 -0.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4402",
    "data-name": "Trazado 4402",
    className: "cls-1",
    d: "M628.816,187.688l-1.465-1.465L617.064,196.51l-3.923-3.922-1.465,1.465,3.922,3.922,0,0,1.466,1.465,0,0,0,0,1.465-1.465,0,0Z",
    transform: "translate(0 -0.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4403",
    "data-name": "Trazado 4403",
    className: "cls-1",
    d: "M618.633,179.6a1.608,1.608,0,1,1,1.608,1.608,1.607,1.607,0,0,1-1.608-1.608",
    transform: "translate(0 -0.88)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentosFirmadosNormal);
export default __webpack_public_path__ + "static/media/documentosFirmadosNormal.6431b8eed865ebfbca8401bb2a5e6eae.svg";
export { ForwardRef as ReactComponent };